import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

const authConfig = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("usertoken")}`,
  },
});

export function getProfile() {
  return axios.get(`${API_END_POINT}/users/profile`, authConfig());
}

export function updateProfile(profileData) {
  return axios.put(`${API_END_POINT}/users/profile`, profileData, authConfig());
}
